

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Bar, Line, Pie } from "react-chartjs-2";
// import { BsBoxes } from "react-icons/bs";
// import { 
//   Chart as ChartJS, 
//   CategoryScale, 
//   LinearScale, 
//   BarElement, 
//   LineElement,
//   PointElement,
//   Title, 
//   Tooltip, 
//   Legend,
//   ArcElement
// } from "chart.js";
// import AdminHome from "../AdminHome";
// import "./AdminDashBoard.css";
// import { IoWarningOutline } from "react-icons/io5";
// import { BiPackage } from "react-icons/bi";
// import { FaLayerGroup } from "react-icons/fa";
// import { GrMoney } from "react-icons/gr";

// // Register necessary components for Chart.js
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   LineElement,
//   PointElement,
//   ArcElement,
//   Title,
//   Tooltip,
//   Legend
// );

// const AdminDashboard = () => {
//   const [dashboardStats, setDashboardStats] = useState({
//     totalProducts: 0,
//     totalInventoryCount: 0,
//     inStockCount: 0,
//     outOfStockCount: 0,
//     totalOrders: 0,
//     revenue: 0,
//   });

//   // State for chart data
//   const [ordersChartData, setOrdersChartData] = useState({
//     labels: [],
//     datasets: [
//       {
//         label: "Orders",
//         data: [],
//         borderColor: "rgba(75, 192, 192, 1)",
//         backgroundColor: "rgba(75, 192, 192, 0.2)",
//         borderWidth: 2,
//         tension: 0.1,
//       },
//     ],
//   });

//   const [revenueChartData, setRevenueChartData] = useState({
//     labels: [],
//     datasets: [
//       {
//         label: "Revenue (₹)",
//         data: [],
//         borderColor: "rgba(153, 102, 255, 1)",
//         backgroundColor: "rgba(153, 102, 255, 0.2)",
//         borderWidth: 2,
//         tension: 0.1,
//       },
//     ],
//   });

  
//   const [productsChartData, setProductsChartData] = useState({
//     labels: [],
//     datasets: [
//       {
//         label: "Products Sold",
//         data: [],
//         borderColor: "rgba(255, 99, 132, 1)",
//         backgroundColor: "rgba(255, 99, 132, 0.2)",
//         borderWidth: 2,
//         tension: 0.1,
//       },
//     ],
//   });

//   // New state for category distribution pie chart
//   const [categoryChartData, setCategoryChartData] = useState({
//     labels: [],
//     datasets: [
//       {
//         label: "Products by Category",
//         data: [],
//         backgroundColor: [
//           'rgba(255, 99, 132, 0.6)',
//           'rgba(54, 162, 235, 0.6)',
//           'rgba(255, 206, 86, 0.6)',
//           'rgba(75, 192, 192, 0.6)',
//           'rgba(153, 102, 255, 0.6)',
//           'rgba(255, 159, 64, 0.6)',
//           'rgba(199, 199, 199, 0.6)',
//           'rgba(83, 102, 255, 0.6)',
//           'rgba(40, 159, 64, 0.6)',
//           'rgba(210, 199, 199, 0.6)',
//         ],
//         borderColor: [
//           'rgba(255, 99, 132, 1)',
//           'rgba(54, 162, 235, 1)',
//           'rgba(255, 206, 86, 1)',
//           'rgba(75, 192, 192, 1)',
//           'rgba(153, 102, 255, 1)',
//           'rgba(255, 159, 64, 1)',
//           'rgba(199, 199, 199, 1)',
//           'rgba(83, 102, 255, 1)',
//           'rgba(40, 159, 64, 1)',
//           'rgba(210, 199, 199, 1)',
//         ],
//         borderWidth: 1,
//       },
//     ],
//   });

//   // Individual filter states for each chart
//   const [ordersFilter, setOrdersFilter] = useState({
//     period: "month",
//     year: new Date().getFullYear(),
//     month: new Date().getMonth() + 1
//   });
  
//   const [revenueFilter, setRevenueFilter] = useState({
//     period: "month",
//     year: new Date().getFullYear(),
//     month: new Date().getMonth() + 1
//   });
  
//   const [productsFilter, setProductsFilter] = useState({
//     period: "month",
//     year: new Date().getFullYear(),
//     month: new Date().getMonth() + 1
//   });
  
//   const [availableYears, setAvailableYears] = useState([]);
//   const [isLoading, setIsLoading] = useState({
//     orders: true,
//     revenue: true,
//     products: true,
//     categories: true
//   });

//   // Fetch dashboard stats
//   useEffect(() => {
//     axios
//       .get("/api/dashboard")
//       .then((response) => {
//         setDashboardStats(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching dashboard stats:", error);
//       });
//   }, []);

//   // Fetch available years for orders data
//   useEffect(() => {
//     axios
//       .get("/api/orders/years")
//       .then((response) => {
//         const years = response.data.years || [];
//         setAvailableYears(years);
        
//         // Set default years if available
//         if (years.length > 0) {
//           const mostRecentYear = years[years.length - 1];
          
//           if (!years.includes(ordersFilter.year)) {
//             setOrdersFilter(prev => ({...prev, year: mostRecentYear}));
//           }
          
//           if (!years.includes(revenueFilter.year)) {
//             setRevenueFilter(prev => ({...prev, year: mostRecentYear}));
//           }
          
//           if (!years.includes(productsFilter.year)) {
//             setProductsFilter(prev => ({...prev, year: mostRecentYear}));
//           }
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching available years:", error);
//         // Fallback to current and previous years if API fails
//         const currentYear = new Date().getFullYear();
//         setAvailableYears([currentYear - 1, currentYear]);
//       });
//   }, []);

//   // Fetch category distribution data
//   useEffect(() => {
//     setIsLoading(prev => ({...prev, categories: true}));
    
//     axios
//       .get("/api/products/categories/distribution")
//       .then((response) => {
//         const { categories } = response.data;
        
//         // Update category chart
//         setCategoryChartData({
//           labels: categories.map(item => item.categoryName),
//           datasets: [
//             {
//               ...categoryChartData.datasets[0],
//               data: categories.map(item => item.count),
//             },
//           ],
//         });
        
//         setIsLoading(prev => ({...prev, categories: false}));
//       })
//       .catch((error) => {
//         console.error("Error fetching category distribution:", error);
//         setIsLoading(prev => ({...prev, categories: false}));
        
//         // Set dummy data if API fails
//         const dummyCategoryData = [
//           { categoryName: "Silver Nano", count: 12 },
//           { categoryName: "Home Care", count: 8 },
//           { categoryName: "Personal Care", count: 15 },
//           { categoryName: "Auto Care", count: 10 },
//           { categoryName: "Pet Care", count: 6 }
//         ];
        
//         setCategoryChartData({
//           labels: dummyCategoryData.map(item => item.categoryName),
//           datasets: [
//             {
//               ...categoryChartData.datasets[0],
//               data: dummyCategoryData.map(item => item.count),
//             },
//           ],
//         });
//       });
//   }, []);

//   // Fetch orders chart data
//   useEffect(() => {
//     setIsLoading(prev => ({...prev, orders: true}));
    
//     // Determine the API endpoint based on the selected period
//     let endpoint = "";
//     if (ordersFilter.period === "month") {
//       endpoint = `/api/analytics/${ordersFilter.period}/${ordersFilter.year}/${ordersFilter.month}`;
//     } else if (ordersFilter.period === "year") {
//       endpoint = `/api/analytics/${ordersFilter.period}/${ordersFilter.year}`;
//     } else {
//       endpoint = `/api/analytics/${ordersFilter.period}`;
//     }

//     axios
//       .get(endpoint)
//       .then((response) => {
//         const { orders } = response.data;
        
//         // Update orders chart
//         setOrdersChartData({
//           labels: orders.map(item => item.label),
//           datasets: [
//             {
//               ...ordersChartData.datasets[0],
//               data: orders.map(item => item.count),
//             },
//           ],
//         });
        
//         setIsLoading(prev => ({...prev, orders: false}));
//       })
//       .catch((error) => {
//         console.error("Error fetching orders data:", error);
//         setIsLoading(prev => ({...prev, orders: false}));
        
//         // Set dummy data if API fails
//         const dummyLabels = getDummyLabels(ordersFilter.period);
//         setOrdersChartData({
//           labels: dummyLabels,
//           datasets: [{...ordersChartData.datasets[0], data: generateRandomData(dummyLabels.length, 20)}],
//         });
//       });
//   }, [ordersFilter.period, ordersFilter.year, ordersFilter.month]);

//   // Fetch revenue chart data
//   useEffect(() => {
//     setIsLoading(prev => ({...prev, revenue: true}));
    
//     // Determine the API endpoint based on the selected period
//     let endpoint = "";
//     if (revenueFilter.period === "month") {
//       endpoint = `/api/analytics/${revenueFilter.period}/${revenueFilter.year}/${revenueFilter.month}`;
//     } else if (revenueFilter.period === "year") {
//       endpoint = `/api/analytics/${revenueFilter.period}/${revenueFilter.year}`;
//     } else {
//       endpoint = `/api/analytics/${revenueFilter.period}`;
//     }

//     axios
//       .get(endpoint)
//       .then((response) => {
//         const { revenue } = response.data;
        
//         // Update revenue chart
//         setRevenueChartData({
//           labels: revenue.map(item => item.label),
//           datasets: [
//             {
//               ...revenueChartData.datasets[0],
//               data: revenue.map(item => item.amount),
//             },
//           ],
//         });
        
//         setIsLoading(prev => ({...prev, revenue: false}));
//       })
//       .catch((error) => {
//         console.error("Error fetching revenue data:", error);
//         setIsLoading(prev => ({...prev, revenue: false}));
        
//         // Set dummy data if API fails
//         const dummyLabels = getDummyLabels(revenueFilter.period);
//         setRevenueChartData({
//           labels: dummyLabels,
//           datasets: [{...revenueChartData.datasets[0], data: generateRandomData(dummyLabels.length, 5000)}],
//         });
//       });
//   }, [revenueFilter.period, revenueFilter.year, revenueFilter.month]);

//   // Fetch products chart data
//   useEffect(() => {
//     setIsLoading(prev => ({...prev, products: true}));
    
//     // Determine the API endpoint based on the selected period
//     let endpoint = "";
//     if (productsFilter.period === "month") {
//       endpoint = `/api/analytics/${productsFilter.period}/${productsFilter.year}/${productsFilter.month}`;
//     } else if (productsFilter.period === "year") {
//       endpoint = `/api/analytics/${productsFilter.period}/${productsFilter.year}`;
//     } else {
//       endpoint = `/api/analytics/${productsFilter.period}`;
//     }

//     axios
//       .get(endpoint)
//       .then((response) => {
//         const { products } = response.data;
        
//         // Update products chart
//         setProductsChartData({
//           labels: products.map(item => item.label),
//           datasets: [
//             {
//               ...productsChartData.datasets[0],
//               data: products.map(item => item.count),
//             },
//           ],
//         });
        
//         setIsLoading(prev => ({...prev, products: false}));
//       })
//       .catch((error) => {
//         console.error("Error fetching products data:", error);
//         setIsLoading(prev => ({...prev, products: false}));
        
//         // Set dummy data if API fails
//         const dummyLabels = getDummyLabels(productsFilter.period);
//         setProductsChartData({
//           labels: dummyLabels,
//           datasets: [{...productsChartData.datasets[0], data: generateRandomData(dummyLabels.length, 50)}],
//         });
//       });
//   }, [productsFilter.period, productsFilter.year, productsFilter.month]);

//   // Helper function to get dummy labels based on period
//   const getDummyLabels = (period) => {
//     switch(period) {
//       case "month":
//         return Array.from({ length: 31 }, (_, i) => (i + 1).toString());
//       case "year":
//         return ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
//       case "week":
//       default:
//         return ["Week 1", "Week 2", "Week 3", "Week 4"];
//     }
//   };

//   // Helper function to generate random data
//   const generateRandomData = (length, max) => {
//     return Array.from({ length }, () => Math.floor(Math.random() * max));
//   };

//   // Chart options
//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         position: "top",
//       },
//       title: {
//         display: false
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//       },
//     },
//   };

//   // Pie chart options - no need for y-axis scale
//   const pieChartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         position: "right",
//         display: true
//       },
//       title: {
//         display: false
//       },
//       tooltip: {
//         callbacks: {
//           label: function(context) {
//             const label = context.label || '';
//             const value = context.raw || 0;
//             const total = context.dataset.data.reduce((a, b) => a + b, 0);
//             const percentage = ((value / total) * 100).toFixed(1);
//             return `${label}: ${value} (${percentage}%)`;
//           }
//         }
//       }
//     },
//   };

//   // Generate months for dropdown
//   const months = [
//     { value: 1, label: "January" },
//     { value: 2, label: "February" },
//     { value: 3, label: "March" },
//     { value: 4, label: "April" },
//     { value: 5, label: "May" },
//     { value: 6, label: "June" },
//     { value: 7, label: "July" },
//     { value: 8, label: "August" },
//     { value: 9, label: "September" },
//     { value: 10, label: "October" },
//     { value: 11, label: "November" },
//     { value: 12, label: "December" },
//   ];

//   // Filter component for reusability
//   const FilterControls = ({ title, filter, setFilter, isLoading }) => (
//     <div className="chartHeader">
//       <h4>{title} {isLoading && "(Loading...)"}</h4>
//       <div className="chartFilters">
//         <div className="filterGroup">
//           <select 
//             value={filter.period} 
//             onChange={(e) => setFilter({...filter, period: e.target.value})}
//             className="form-select form-select-sm"
//           >
//             <option value="week">Week</option>
//             <option value="month">Month</option>
//             <option value="year">Year</option>
//           </select>
//         </div>
        
//         <div className="filterGroup">
//           <select 
//             value={filter.year} 
//             onChange={(e) => setFilter({...filter, year: parseInt(e.target.value)})}
//             className="form-select form-select-sm"
//           >
//             {availableYears.map(year => (
//               <option key={year} value={year}>{year}</option>
//             ))}
//           </select>
//         </div>
        
//         {filter.period === "month" && (
//           <div className="filterGroup">
//             <select 
//               value={filter.month} 
//               onChange={(e) => setFilter({...filter, month: parseInt(e.target.value)})}
//               className="form-select form-select-sm"
//             >
//               {months.map(month => (
//                 <option key={month.value} value={month.value}>{month.label}</option>
//               ))}
//             </select>
//           </div>
//         )}
//       </div>
//     </div>
//   );

//   return (
//     <>
//       <div className="breadcrumb-wrap bg-f">
//         {/* Breadcrumb content if needed */}
//       </div>
      
//       <div className="containerorder">
        
//         <div className="row">
       
//           <div className="col-xl-3 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
           
//           <AdminHome />
//           </div>
          
//           <div className="col-xl-9 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
//             {/* Stats Cards */}
            // <div className="cardContainer">
            //   <div className="card card1">
            //     <div className="iconbox"><BsBoxes size={28} /></div>
            //     <p className="heading_mrp_new">{dashboardStats.totalProducts}</p>
            //     <h6>Total Products</h6>
            //   </div>
            //   <div className="card card2">
            //     <div className="iconbox"><FaLayerGroup size={28} /></div>
            //     <p className="heading_mrp_new">{dashboardStats.totalInventoryCount}</p>
            //     <h6>Total Inventory</h6>
            //   </div>
            //   <div className="card card3">
            //     <div className="iconbox"><BsBoxes size={28} /></div>
            //     <p className="heading_mrp_new">{dashboardStats.inStockCount}</p>
            //     <h6>In Stock</h6>
            //   </div>
            //   <div className="card card4">
            //     <div className="iconbox"><IoWarningOutline size={28} /></div>
            //     <p className="heading_mrp_new">{dashboardStats.outOfStockCount}</p>
            //     <h6>Out of Stock</h6>
            //   </div>
            //   <div className="card card5">
            //     <div className="iconbox"><BiPackage size={28} /></div>
            //     <p className="heading_mrp_new">{dashboardStats.totalOrders}</p>
            //     <h6>Total Orders</h6>
            //   </div>
            //   <div className="card card6">
            //     <div className="iconbox"><GrMoney size={28} /></div>
            //     <p className="heading_mrp_new">₹{dashboardStats.revenue.toFixed(2)}</p>
            //     <h6>Total Revenue</h6>
            //   </div>
            // </div>
            
//             <div className="analyticsHeader">
//               <h3>Analytics Dashboard</h3>
//             </div>
            
//             {/* Orders and Revenue Charts in same row */}
//             <div className="chartsRow">
//               <div className="chartBox">
//                 <FilterControls 
//                   title="Orders" 
//                   filter={ordersFilter} 
//                   setFilter={setOrdersFilter} 
//                   isLoading={isLoading.orders}
//                 />
//                 <div className="chartWrapper">
//                   <Line data={ordersChartData} options={chartOptions} height={300} />
//                 </div>
//               </div>
              
//               <div className="chartBox">
//                 <FilterControls 
//                   title="Revenue" 
//                   filter={revenueFilter} 
//                   setFilter={setRevenueFilter} 
//                   isLoading={isLoading.revenue}
//                 />
//                 <div className="chartWrapper">
//                   <Line data={revenueChartData} options={chartOptions} height={300} />
//                 </div>
//               </div>
//             </div>
            
//             {/* Products Chart and Category Distribution in the same row */}
//             <div className="chartsRow">
//               <div className="chartBox">
//                 <FilterControls 
//                   title="Products Sold" 
//                   filter={productsFilter} 
//                   setFilter={setProductsFilter}
//                   isLoading={isLoading.products}
//                 />
//                 <div className="chartWrapper">
//                   <Line data={productsChartData} options={chartOptions} height={300} />
//                 </div>
//               </div>
              
//               {/* New Category Distribution Pie Chart */}
//               <div className="chartBox">
//                 <div className="chartHeader">
//                   <h4>Product Categories {isLoading.categories && "(Loading...)"}</h4>
//                 </div>
//                 <div className="chartWrapper pieChartWrapper">
//                   <Pie data={categoryChartData} options={pieChartOptions} height={300} />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AdminDashboard;


///crt working code
// import React, { useState, useEffect } from 'react';
// import { Line, Pie } from 'react-chartjs-2';
// import { 
//   Chart as ChartJS, 
//   CategoryScale, 
//   LinearScale, 
//   BarElement, 
//   LineElement,
//   PointElement,
//   Title, 
//   Tooltip, 
//   Legend,
//   ArcElement
// } from 'chart.js';
// import { Loader2, Package, Archive, ShoppingCart, DollarSign, AlertCircle } from 'lucide-react';
// import AdminHome from '../AdminHome';

// // Register necessary components for Chart.js
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   LineElement,
//   PointElement,
//   ArcElement,
//   Title,
//   Tooltip,
//   Legend
// );

// const SalesDashboard = () => {
//   const [products, setProducts] = useState([]);
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
  
//   // Dashboard stats
//   const [dashboardStats, setDashboardStats] = useState({
//     totalProducts: 0,
//     totalInventoryCount: 0,
//     inStockCount: 0,
//     outOfStockCount: 0,
//     totalOrders: 0,
//     revenue: 0,
//   });

//   // Chart data states
//   const [ordersChartData, setOrdersChartData] = useState({
//     labels: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
//     datasets: [
//       {
//         label: "Orders",
//         data: [5, 10, 8, 12],
//         borderColor: "rgba(75, 192, 192, 1)",
//         backgroundColor: "rgba(75, 192, 192, 0.2)",
//         borderWidth: 2,
//         tension: 0.1,
//       },
//     ],
//   });

//   const [revenueChartData, setRevenueChartData] = useState({
//     labels: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
//     datasets: [
//       {
//         label: "Revenue ($)",
//         data: [1500, 2200, 1800, 3000],
//         borderColor: "rgba(153, 102, 255, 1)",
//         backgroundColor: "rgba(153, 102, 255, 0.2)",
//         borderWidth: 2,
//         tension: 0.1,
//       },
//     ],
//   });

//   const [categoryChartData, setCategoryChartData] = useState({
//     labels: ['Category 1', 'Category 2', 'Category 3', 'Category 4'],
//     datasets: [
//       {
//         label: "Products by Category",
//         data: [12, 19, 8, 5],
//         backgroundColor: [
//           'rgba(255, 99, 132, 0.6)',
//           'rgba(54, 162, 235, 0.6)',
//           'rgba(255, 206, 86, 0.6)',
//           'rgba(75, 192, 192, 0.6)',
//         ],
//         borderColor: [
//           'rgba(255, 99, 132, 1)',
//           'rgba(54, 162, 235, 1)',
//           'rgba(255, 206, 86, 1)',
//           'rgba(75, 192, 192, 1)',
//         ],
//         borderWidth: 1,
//       },
//     ],
//   });

//   // Filter states
//   const [ordersFilter, setOrdersFilter] = useState({
//     period: "month",
//     year: new Date().getFullYear(),
//     month: new Date().getMonth() + 1
//   });
  
//   const [revenueFilter, setRevenueFilter] = useState({
//     period: "month",
//     year: new Date().getFullYear(),
//     month: new Date().getMonth() + 1
//   });
  
//   const [availableYears, setAvailableYears] = useState([
//     new Date().getFullYear() - 1,
//     new Date().getFullYear()
//   ]);
  
//   const [isLoading, setIsLoading] = useState({
//     orders: false,
//     revenue: false,
//     categories: false
//   });

//   // Fetch product and order data
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [ordersResponse, productsResponse] = await Promise.all([
//           fetch('/api/orders'),
//           fetch('/api/all/products')
//         ]);
        
//         const ordersData = await ordersResponse.json();
//         const productsData = await productsResponse.json();
        
//         setOrders(ordersData);
//         setProducts(productsData);
        
//         // Calculate dashboard stats
//         const totalProducts = productsData.length;
//         const totalInventory = productsData.reduce((sum, product) =>
//           sum + product.size.reduce((acc, size) => acc + size.quantity, 0), 0);
//         const inStockProducts = productsData.filter(product => 
//           product.size.some(size => size.quantity > 0)).length;
//         const outOfStockProducts = productsData.filter(product => 
//           product.size.every(size => size.quantity === 0)).length;
//         const totalOrders = ordersData.length;
//         const revenue = orders.reduce((sum, order) => {
//           const orderTotal = order.products.reduce((productSum, product) => {
//             return productSum + (product.price * product.quantity);
//           }, 0);
//           return sum + orderTotal;
//         }, 0);
        
        
//         setDashboardStats({
//           totalProducts,
//           totalInventoryCount: totalInventory,
//           inStockCount: inStockProducts,
//           outOfStockCount: outOfStockProducts,
//           totalOrders,
//           revenue
//         });
        
//         // Process order data for charts
//         processOrdersForCharts(ordersData);
//         processProductCategories(productsData);
        
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setLoading(false);
//       }
//     };
    
//     fetchData();
//   }, []);

//   // Process orders data for charts whenever filter changes
//   useEffect(() => {
//     if (orders.length > 0) {
//       processOrdersForCharts(orders);
//     }
//   }, [ordersFilter.period, ordersFilter.year, ordersFilter.month, orders]);

//   // Process orders data for charts
//   const processOrdersForCharts = (ordersData) => {
//     setIsLoading({...isLoading, orders: true, revenue: true});
    
//     // Filter orders based on selected period
//     const filteredOrders = filterOrdersByPeriod(ordersData, ordersFilter);
    
//     // Group orders by date for the selected period
//     const groupedData = groupOrdersByPeriod(filteredOrders, ordersFilter.period);
    
//     // Update orders chart
//     setOrdersChartData({
//       labels: Object.keys(groupedData),
//       datasets: [
//         {
//           ...ordersChartData.datasets[0],
//           data: Object.values(groupedData).map(group => group.count),
//         },
//       ],
//     });
    
//     // Update revenue chart
//     setRevenueChartData({
//       labels: Object.keys(groupedData),
//       datasets: [
//         {
//           ...revenueChartData.datasets[0],
//           data: Object.values(groupedData).map(group => group.revenue),
//         },
//       ],
//     });
    
//     setIsLoading({...isLoading, orders: false, revenue: false});
//   };

//   // Process product categories for pie chart
//   const processProductCategories = (productsData) => {
//     setIsLoading({...isLoading, categories: true});
    
//     // Count products by category
//     const categoryCounts = {};
//     productsData.forEach(product => {
//       const category = product.category || 'Uncategorized';
//       categoryCounts[category] = (categoryCounts[category] || 0) + 1;
//     });
    
//     // Update category chart
//     setCategoryChartData({
//       labels: Object.keys(categoryCounts),
//       datasets: [
//         {
//           ...categoryChartData.datasets[0],
//           data: Object.values(categoryCounts),
//         },
//       ],
//     });
    
//     setIsLoading({...isLoading, categories: false});
//   };

//   // Helper function to filter orders by period
//   const filterOrdersByPeriod = (ordersData, filter) => {
//     return ordersData.filter(order => {
//       const orderDate = new Date(order.createdAt || order.date || Date.now());
//       const orderYear = orderDate.getFullYear();
//       const orderMonth = orderDate.getMonth() + 1;
      
//       if (filter.period === "year") {
//         return orderYear === filter.year;
//       } else if (filter.period === "month") {
//         return orderYear === filter.year && orderMonth === filter.month;
//       }
//       // For weekly view, we'd need more complex logic, but for demo we'll just return all
//       return true;
//     });
//   };

//   // Helper function to group orders by period
//   const groupOrdersByPeriod = (orders, period) => {
//     const grouped = {};
    
//     if (period === "year") {
//       // Group by month for year view
//       for (let i = 1; i <= 12; i++) {
//         const monthName = new Date(2000, i-1, 1).toLocaleString('default', { month: 'short' });
//         grouped[monthName] = { count: 0, revenue: 0 };
//       }
      
//       orders.forEach(order => {
//         const orderDate = new Date(order.createdAt || order.date || Date.now());
//         const monthIndex = orderDate.getMonth();
//         const monthName = new Date(2000, monthIndex, 1).toLocaleString('default', { month: 'short' });
        
//         grouped[monthName].count++;
//         grouped[monthName].revenue += order.productPrice || 0;
//       });
//     } else if (period === "month") {
//       // Group by day for month view
//       const daysInMonth = new Date(ordersFilter.year, ordersFilter.month, 0).getDate();
      
//       for (let i = 1; i <= daysInMonth; i++) {
//         grouped[i] = { count: 0, revenue: 0 };
//       }
      
//       orders.forEach(order => {
//         const orderDate = new Date(order.createdAt || order.date || Date.now());
//         const day = orderDate.getDate();
        
//         if (grouped[day]) {
//           grouped[day].count++;
//           grouped[day].revenue += order.productPrice || 0;
//         }
//       });
//     } else {
//       // Weekly view - group by weekday
//       const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
//       weekdays.forEach(day => {
//         grouped[day] = { count: 0, revenue: 0 };
//       });
      
//       orders.forEach(order => {
//         const orderDate = new Date(order.createdAt || order.date || Date.now());
//         const weekday = weekdays[orderDate.getDay()];
        
//         grouped[weekday].count++;
//         grouped[weekday].revenue += order.productPrice || 0;
//       });
//     }
    
//     return grouped;
//   };

//   // Chart options
//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         position: "top",
//       },
//       title: {
//         display: false
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//       },
//     },
//   };

//   // Pie chart options
//   const pieChartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         position: "right",
//         display: true
//       },
//       title: {
//         display: false
//       },
//       tooltip: {
//         callbacks: {
//           label: function(context) {
//             const label = context.label || '';
//             const value = context.raw || 0;
//             const total = context.dataset.data.reduce((a, b) => a + b, 0);
//             const percentage = ((value / total) * 100).toFixed(1);
//             return `${label}: ${value} (${percentage}%)`;
//           }
//         }
//       }
//     },
//   };

//   // Generate months for dropdown
//   const months = [
//     { value: 1, label: "January" },
//     { value: 2, label: "February" },
//     { value: 3, label: "March" },
//     { value: 4, label: "April" },
//     { value: 5, label: "May" },
//     { value: 6, label: "June" },
//     { value: 7, label: "July" },
//     { value: 8, label: "August" },
//     { value: 9, label: "September" },
//     { value: 10, label: "October" },
//     { value: 11, label: "November" },
//     { value: 12, label: "December" },
//   ];

//   // Filter component for reusability
//   const FilterControls = ({ title, filter, setFilter, isLoading }) => (
//     <div className="flex justify-between items-center mb-4">
//       <h4 className="text-lg font-semibold">{title} {isLoading && "(Loading...)"}</h4>
//       <div className="flex space-x-2">
//         <select 
//           value={filter.period} 
//           onChange={(e) => setFilter({...filter, period: e.target.value})}
//           className="p-1 text-sm border rounded"
//         >
//           <option value="week">Week</option>
//           <option value="month">Month</option>
//           <option value="year">Year</option>
//         </select>
        
//         <select 
//           value={filter.year} 
//           onChange={(e) => setFilter({...filter, year: parseInt(e.target.value)})}
//           className="p-1 text-sm border rounded"
//         >
//           {availableYears.map(year => (
//             <option key={year} value={year}>{year}</option>
//           ))}
//         </select>
        
//         {filter.period === "month" && (
//           <select 
//             value={filter.month} 
//             onChange={(e) => setFilter({...filter, month: parseInt(e.target.value)})}
//             className="p-1 text-sm border rounded"
//           >
//             {months.map(month => (
//               <option key={month.value} value={month.value}>{month.label}</option>
//             ))}
//           </select>
//         )}
//       </div>
//     </div>
//   );

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-screen">
//         <Loader2 className="h-8 w-8 animate-spin text-blue-500" />
//         <span className="ml-2">Loading dashboard data...</span>
//       </div>
//     );
//   }

//   return (
// <>
// <AdminHome/>

// <div style={{marginLeft:'350px',marginTop:'-420px'}}>
   
    
      
      
//       <div style={{
//   display: 'flex',
//   flexWrap: 'wrap',
//   gap: '16px',
//   marginBottom: '24px'
// }}>
//   {[
//     {
//       icon: <Package size={24} />,
//       label: 'Total Products',
//       value: dashboardStats.totalProducts,
//       bgColor: '#dbeafe',
//       color: '#2563eb',
//     },
//     {
//       icon: <Archive size={24} />,
//       label: 'Total Inventory',
//       value: dashboardStats.totalInventoryCount,
//       bgColor: '#d1fae5',
//       color: '#10b981',
//     },
//     {
//       icon: <Package size={24} />,
//       label: 'In Stock',
//       value: dashboardStats.inStockCount,
//       bgColor: '#d1fae5',
//       color: '#10b981',
//     },
//     {
//       icon: <AlertCircle size={24} />,
//       label: 'Out of Stock',
//       value: dashboardStats.outOfStockCount,
//       bgColor: '#fee2e2',
//       color: '#ef4444',
//     },
//     {
//       icon: <ShoppingCart size={24} />,
//       label: 'Total Orders',
//       value: dashboardStats.totalOrders,
//       bgColor: '#ede9fe',
//       color: '#8b5cf6',
//     },
//     {
//       icon: <DollarSign size={24} />,
//       label: 'Total Revenue',
//       value: `$${dashboardStats.revenue.toFixed(2)}`,
//       bgColor: '#fef3c7',
//       color: '#f59e0b',
//     }
//   ].map((card, index) => (
//     <div
//       key={index}
//       style={{
//         background: '#fff',
//         borderRadius: '8px',
//         boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
//         padding: '16px',
//         flex: '1 1 calc(33.33% - 16px)',
//         minWidth: '250px',
//         display: 'flex',
//         alignItems: 'center'
//       }}
//     >
//       <div style={{
//         backgroundColor: card.bgColor,
//         color: card.color,
//         padding: '12px',
//         borderRadius: '50%',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         marginRight: '12px'
//       }}>
//         {card.icon}
//       </div>
//       <div>
//         <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>{card.label}</p>
//         <p style={{ fontSize: '20px', fontWeight: 'bold', margin: 0 }}>{card.value}</p>
//       </div>
//     </div>
//   ))}
// </div>

      
// <div style={{ marginBottom: '24px' }}>
//   <h3 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '16px' }}>Analytics Dashboard</h3>
// </div>

// <div style={{ display: 'flex', gap: '24px', marginBottom: '24px', flexWrap: 'wrap' }}>
//   {/* Orders Chart */}
//   <div style={{
//     background: '#fff',
//     borderRadius: '8px',
//     boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
//     padding: '16px',
//     flex: '1 1 45%',
//     minWidth: '300px'
//   }}>
//     <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
//       <h4 style={{ fontSize: '16px', fontWeight: '600', margin: 0 }}>Orders</h4>
//       <FilterControls
//         filter={ordersFilter}
//         setFilter={setOrdersFilter}
//         isLoading={isLoading.orders}
//       />
//     </div>
//     <div style={{ height: '256px' }}>
//       <Line data={ordersChartData} options={chartOptions} />
//     </div>
//   </div>

//   {/* Revenue Chart */}
//   <div style={{
//     background: '#fff',
//     borderRadius: '8px',
//     boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
//     padding: '16px',
//     flex: '1 1 45%',
//     minWidth: '300px'
//   }}>
//     <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
//       <h4 style={{ fontSize: '16px', fontWeight: '600', margin: 0 }}>Revenue</h4>
//       <FilterControls
//         filter={revenueFilter}
//         setFilter={setRevenueFilter}
//         isLoading={isLoading.revenue}
//       />
//     </div>
//     <div style={{ height: '256px' }}>
//       <Line data={revenueChartData} options={chartOptions} />
//     </div>
//   </div>
// </div>



// {/* Product Categories Pie Chart */}
// <div style={{
//   background: '#fff',
//   borderRadius: '8px',
//   boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
//   padding: '16px',
//   marginBottom: '24px',
//   minWidth: '300px'
// }}>
//   <div style={{
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '16px'
//   }}>
//     <h4 style={{ fontSize: '18px', fontWeight: '600' }}>
//       Product Categories {isLoading.categories && "(Loading...)"}
//     </h4>
//   </div>
//   <div style={{ height: '256px' }}>
//     <Pie data={categoryChartData} options={pieChartOptions} />
//   </div>
// </div>

// {/* Recent Orders Table */}
// <div style={{
//   background: '#fff',
//   borderRadius: '8px',
//   boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
//   padding: '16px',
//   marginBottom: '24px'
// }}>
//   <h4 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '16px' }}>Recent Orders</h4>
//   <div style={{ overflowX: 'auto' }}>
//     <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//       <thead style={{ backgroundColor: '#f9fafb' }}>
//         <tr>
//           {['Order ID', 'Date', 'Amount', 'Status'].map((heading) => (
//             <th key={heading} style={{
//               padding: '12px 24px',
//               textAlign: 'left',
//               fontSize: '12px',
//               fontWeight: '600',
//               color: '#6b7280',
//               textTransform: 'uppercase',
//               borderBottom: '1px solid #e5e7eb'
//             }}>{heading}</th>
//           ))}
//         </tr>
//       </thead>
//       <tbody>
//         {orders.slice(0, 5).map((order, index) => (
//           <tr key={order._id || index} style={{ borderBottom: '1px solid #e5e7eb' }}>
//             <td >#{(order._id || index.toString()).slice(-6)}</td>
//             <td >
//               {new Date(order.createdAt || order.date || Date.now()).toLocaleDateString()}
//             </td>
//             <td >${order.productPrice?.toFixed(2) || '0.00'}</td>
//             <td >
//               <span style={{
//                 padding: '2px 8px',
//                 backgroundColor: '#d1fae5',
//                 color: '#065f46',
//                 fontSize: '12px',
//                 fontWeight: '600',
//                 borderRadius: '9999px'
//               }}>
//                 {order.status || 'Completed'}
//               </span>
//             </td>
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   </div>
// </div>



//     </div>
//     </>
//   );
// };

// export default SalesDashboard;

////full working code

import React, { useState, useEffect } from 'react';
import { Line, Pie } from 'react-chartjs-2';
import { FaIndianRupeeSign } from "react-icons/fa6";
 import { IoCloseSharp } from "react-icons/io5";
 import { BsMenuButtonWideFill } from "react-icons/bs";
import { 
  Chart as ChartJS, 
  CategoryScale, 
  LinearScale, 
  BarElement, 
  LineElement,
  PointElement,
  Title, 
  Tooltip, 
  Legend,
  ArcElement
} from 'chart.js';
import { Loader2, Package, Archive, ShoppingCart, DollarSign, AlertCircle } from 'lucide-react';
import AdminHome from '../AdminHome';
import './AdminDashBoard.css';
import { BsBoxes } from "react-icons/bs";
// Register necessary components for Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);



const SalesDashboard = () => {
  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Dashboard stats
  const [dashboardStats, setDashboardStats] = useState({
    totalProducts: 0,
    totalInventoryCount: 0,
    inStockCount: 0,
    outOfStockCount: 0,
    totalOrders: 0,
    revenue: 0,
  });

  // Chart data states
  const [ordersChartData, setOrdersChartData] = useState({
    labels: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
    datasets: [
      {
        label: "Orders",
        data: [5, 10, 8, 12],
        borderColor: "rgba(75, 192, 192, 1)",
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        borderWidth: 2,
        tension: 0.1,
      },
    ],
  });

  const [revenueChartData, setRevenueChartData] = useState({
    labels: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
    datasets: [
      {
        label: "Revenue (Rs)",
        data: [1500, 2200, 1800, 3000],
        borderColor: "rgba(153, 102, 255, 1)",
        backgroundColor: "rgba(153, 102, 255, 0.2)",
        borderWidth: 2,
        tension: 0.1,
      },
    ],
  });

  const [categoryChartData, setCategoryChartData] = useState({
    labels: ['Category 1', 'Category 2', 'Category 3', 'Category 4'],
    datasets: [
      {
        label: "Products by Category",
        data: [12, 19, 8, 5],
        backgroundColor: [
          'rgba(255, 99, 132, 0.6)',
          'rgba(54, 162, 235, 0.6)',
          'rgba(255, 206, 86, 0.6)',
          'rgba(75, 192, 192, 0.6)',
          'rgba(153, 102, 255, 0.6)',
          'rgba(255, 159, 64, 0.6)',
          'rgba(199, 199, 199, 0.6)',
          'rgba(83, 102, 255, 0.6)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)',
          'rgba(199, 199, 199, 1)',
          'rgba(83, 102, 255, 1)',
        ],
        borderWidth: 1,
      },
    ],
  });

  // Filter states
  const [ordersFilter, setOrdersFilter] = useState({
    period: "month",
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  });
  
  const [revenueFilter, setRevenueFilter] = useState({
    period: "month",
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  });
  
  const [availableYears, setAvailableYears] = useState([
    new Date().getFullYear() - 1,
    new Date().getFullYear()
  ]);
  
  const [isLoading, setIsLoading] = useState({
    orders: false,
    revenue: false,
    categories: false
  });

  // Fetch product, order, and category data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [ordersResponse, productsResponse, categoriesResponse] = await Promise.all([
          fetch('/api/orders'),
          fetch('/api/all/products'),
          fetch('/api/categories')
        ]);
        
        const ordersData = await ordersResponse.json();
        const productsData = await productsResponse.json();
        const categoriesData = await categoriesResponse.json();
        
        setOrders(ordersData);
        setProducts(productsData);
        setCategories(categoriesData);
        
        // Calculate dashboard stats
        const totalProducts = productsData.length;
        const totalInventory = productsData.reduce((sum, product) =>
          sum + product.size.reduce((acc, size) => acc + size.quantity, 0), 0);
        const inStockProducts = productsData.filter(product => 
          product.size.some(size => size.quantity > 0)).length;
        const outOfStockProducts = productsData.filter(product => 
          product.size.every(size => size.quantity === 0)).length;
        const totalOrders = ordersData.length;
        // Fix revenue calculation by accessing payment details
      const revenue = ordersData.reduce((sum, order) => {
        // Check for payment details first
        if (order.paymentDetails && order.paymentDetails.amount) {
          return sum + Number(order.paymentDetails.amount);
        }
        
        // Fallback to calculating from products if payment details not available
        const orderTotal = order.products ? order.products.reduce((productSum, product) => {
          return productSum + (product.price * product.quantity);
        }, 0) : 0;
        
        return sum + (orderTotal || (order.productPrice || 0));
      }, 0);
        
        
        setDashboardStats({
          totalProducts,
          totalInventoryCount: totalInventory,
          inStockCount: inStockProducts,
          outOfStockCount: outOfStockProducts,
          totalOrders,
          revenue
        });
        
        // Process order data for charts
        processOrdersForCharts(ordersData);
        // Process product categories with actual category data
        processProductCategories(productsData, categoriesData);
        
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };
    
    fetchData();
  }, []);

  // Process orders data for charts whenever filter changes
  useEffect(() => {
    if (orders.length > 0) {
      processOrdersForCharts(orders);
    }
  }, [ordersFilter.period, ordersFilter.year, ordersFilter.month, orders]);

  // Process orders data for charts
  const processOrdersForCharts = (ordersData) => {
    setIsLoading({...isLoading, orders: true, revenue: true});
    
    // Filter orders based on selected period
    const filteredOrders = filterOrdersByPeriod(ordersData, ordersFilter);
    
    // Group orders by date for the selected period
    const groupedData = groupOrdersByPeriod(filteredOrders, ordersFilter.period);
    
    // Update orders chart
    setOrdersChartData({
      labels: Object.keys(groupedData),
      datasets: [
        {
          ...ordersChartData.datasets[0],
          data: Object.values(groupedData).map(group => group.count),
        },
      ],
    });
    
    // Update revenue chart
    setRevenueChartData({
      labels: Object.keys(groupedData),
      datasets: [
        {
          ...revenueChartData.datasets[0],
          data: Object.values(groupedData).map(group => group.revenue),
        },
      ],
    });
    
    setIsLoading({...isLoading, orders: false, revenue: false});
  };

  // Process product categories for pie chart
  const processProductCategories = (productsData, categoriesData) => {
    setIsLoading({...isLoading, categories: true});
    
    // Count products by category using actual category data
    const categoryCounts = {};
    
    // Initialize counts for all categories to ensure they all appear in the chart
    if (categoriesData && categoriesData.length > 0) {
      categoriesData.forEach(category => {
        categoryCounts[category.name || category.title || category._id] = 0;
      });
    }
    
    // Count products in each category
    productsData.forEach(product => {
      // Get the category ID or name from the product
      const categoryId = product.categoryId || product.category;
      let categoryName = 'Uncategorized';
      
      // Find the category name if we have a category ID
      if (categoryId && categoriesData) {
        const category = categoriesData.find(cat => cat._id === categoryId);
        if (category) {
          categoryName = category.name || category.title;
        }
      } else if (typeof product.category === 'string') {
        // If category is directly a string (name), use it
        categoryName = product.category;
      }
      
      categoryCounts[categoryName] = (categoryCounts[categoryName] || 0) + 1;
    });
    
    // Generate colors for pie chart (ensure we have enough colors)
    const backgroundColors = [
      'rgba(255, 99, 132, 0.6)',
      'rgba(54, 162, 235, 0.6)',
      'rgba(255, 206, 86, 0.6)',
      'rgba(75, 192, 192, 0.6)',
      'rgba(153, 102, 255, 0.6)',
      'rgba(255, 159, 64, 0.6)',
      'rgba(199, 199, 199, 0.6)',
      'rgba(83, 102, 255, 0.6)',
    ];
    
    const borderColors = [
      'rgba(255, 99, 132, 1)',
      'rgba(54, 162, 235, 1)',
      'rgba(255, 206, 86, 1)',
      'rgba(75, 192, 192, 1)',
      'rgba(153, 102, 255, 1)',
      'rgba(255, 159, 64, 1)',
      'rgba(199, 199, 199, 1)',
      'rgba(83, 102, 255, 1)',
    ];
    
    // Generate colors for additional categories if needed
    const categoryNames = Object.keys(categoryCounts);
    if (categoryNames.length > backgroundColors.length) {
      for (let i = backgroundColors.length; i < categoryNames.length; i++) {
        const r = Math.floor(Math.random() * 255);
        const g = Math.floor(Math.random() * 255);
        const b = Math.floor(Math.random() * 255);
        backgroundColors.push(`rgba(${r},${g},${b},0.6)`);
        borderColors.push(`rgba(${r},${g},${b},1)`);
      }
    }
    
    // Update category chart with dynamic data and colors
    setCategoryChartData({
      labels: categoryNames,
      datasets: [
        {
          label: "Products by Category",
          data: Object.values(categoryCounts),
          backgroundColor: backgroundColors.slice(0, categoryNames.length),
          borderColor: borderColors.slice(0, categoryNames.length),
          borderWidth: 1,
        },
      ],
    });
    
    setIsLoading({...isLoading, categories: false});
  };

  // Helper function to filter orders by period
  const filterOrdersByPeriod = (ordersData, filter) => {
    return ordersData.filter(order => {
      const orderDate = new Date(order.createdAt || order.date || Date.now());
      const orderYear = orderDate.getFullYear();
      const orderMonth = orderDate.getMonth() + 1;
      
      if (filter.period === "year") {
        return orderYear === filter.year;
      } else if (filter.period === "month") {
        return orderYear === filter.year && orderMonth === filter.month;
      }
      // For weekly view, we'd need more complex logic, but for demo we'll just return all
      return true;
    });
  };

  // Helper function to group orders by period
  const groupOrdersByPeriod = (orders, period) => {
    const grouped = {};
    
    if (period === "year") {
      // Group by month for year view
      for (let i = 1; i <= 12; i++) {
        const monthName = new Date(2000, i-1, 1).toLocaleString('default', { month: 'short' });
        grouped[monthName] = { count: 0, revenue: 0 };
      }
      
      orders.forEach(order => {
        const orderDate = new Date(order.createdAt || order.date || Date.now());
        const monthIndex = orderDate.getMonth();
        const monthName = new Date(2000, monthIndex, 1).toLocaleString('default', { month: 'short' });
        
        grouped[monthName].count++;
        
        // Calculate order revenue
        const orderRevenue = order.products ? order.products.reduce((sum, product) => 
          sum + (product.price * product.quantity), 0) : (order.productPrice || 0);
          
        grouped[monthName].revenue += orderRevenue;
      });
    } else if (period === "month") {
      // Group by day for month view
      const daysInMonth = new Date(ordersFilter.year, ordersFilter.month, 0).getDate();
      
      for (let i = 1; i <= daysInMonth; i++) {
        grouped[i] = { count: 0, revenue: 0 };
      }
      
      orders.forEach(order => {
        const orderDate = new Date(order.createdAt || order.date || Date.now());
        const day = orderDate.getDate();
        
        if (grouped[day]) {
          grouped[day].count++;
          
          // Calculate order revenue
          const orderRevenue = order.products ? order.products.reduce((sum, product) => 
            sum + (product.price * product.quantity), 0) : (order.productPrice || 0);
            
          grouped[day].revenue += orderRevenue;
        }
      });
    } else {
      // Weekly view - group by weekday
      const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      weekdays.forEach(day => {
        grouped[day] = { count: 0, revenue: 0 };
      });
      
      orders.forEach(order => {
        const orderDate = new Date(order.createdAt || order.date || Date.now());
        const weekday = weekdays[orderDate.getDay()];
        
        grouped[weekday].count++;
        
        // Calculate order revenue
        const orderRevenue = order.products ? order.products.reduce((sum, product) => 
          sum + (product.price * product.quantity), 0) : (order.productPrice || 0);
          
        grouped[weekday].revenue += orderRevenue;
      });
    }
    
    return grouped;
  };

  // Chart options
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: false
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  // Pie chart options
  const pieChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "right",
        display: true
      },
      title: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.raw || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            return `${label}: ${value} (${percentage}%)`;
          }
        }
      }
    },
  };

  // Generate months for dropdown
  const months = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];

  // Filter component for reusability
  const FilterControls = ({ title, filter, setFilter, isLoading }) => (
    <div className="flex justify-between items-center mb-4">
      <h4 className="text-lg font-semibold">{title} {isLoading && "(Loading...)"}</h4>
      <div className="flex space-x-2">
        <select 
          value={filter.period} 
          onChange={(e) => setFilter({...filter, period: e.target.value})}
          className="p-1 text-sm border rounded"
        >
          <option value="week">Week</option>
          <option value="month">Month</option>
          <option value="year">Year</option>
        </select>
        
        <select 
          value={filter.year} 
          onChange={(e) => setFilter({...filter, year: parseInt(e.target.value)})}
          className="p-1 text-sm border rounded"
        >
          {availableYears.map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
        
        {filter.period === "month" && (
          <select 
            value={filter.month} 
            onChange={(e) => setFilter({...filter, month: parseInt(e.target.value)})}
            className="p-1 text-sm border rounded"
          >
            {months.map(month => (
              <option key={month.value} value={month.value}>{month.label}</option>
            ))}
          </select>
        )}
      </div>
    </div>
  );

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-blue-500" />
        <span className="ml-2">Loading dashboard data...</span>
      </div>
    );
  }

  return (
    <>
      <AdminHome/>

      <div className="saleport_container">
        {/* <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '10px',
          marginBottom: '24px'
        }}>
          {[
             {
              icon: <FaIndianRupeeSign  size={24} />,
              label: 'Total Sales',
              value: `₹${dashboardStats.revenue.toFixed(2)}`,
              bgColor: '#fef3c7',
              color: '#f59e0b',
            },
            {
              icon: <Package size={24} />,
              label: 'Total Products',
              value: dashboardStats.totalProducts,
              bgColor: '#dbeafe',
              color: '#2563eb',
            },
            {
              icon: <Archive size={24} />,
              label: 'Total Inventory',
              value: dashboardStats.totalInventoryCount,
              bgColor: '#d1fae5',
              color: '#10b981',
            },
            {
              icon: <Package size={24} />,
              label: 'In Stock',
              value: dashboardStats.inStockCount,
              bgColor: '#d1fae5',
              color: '#10b981',
            },
            {
              icon: <AlertCircle size={24} />,
              label: 'Out of Stock',
              value: dashboardStats.outOfStockCount,
              bgColor: '#fee2e2',
              color: '#ef4444',
            },
            {
              icon: <ShoppingCart size={24} />,
              label: 'Total Orders',
              value: dashboardStats.totalOrders,
              bgColor: '#ede9fe',
              color: '#8b5cf6',
            },
          
          ].map((card, index) => (
            <div
              key={index}
              style={{
                background: '#fff',
                borderRadius: '8px',
                boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                padding: '16px',
                flex: '1 1 calc(33.33% - 16px)',
                minWidth: '250px',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <div style={{
                backgroundColor: card.bgColor,
                color: card.color,
                padding: '12px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '12px'
              }}>
                {card.icon}
              </div>
              <div>
                <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>{card.label}</p>
                <p style={{ fontSize: '20px', fontWeight: 'bold', margin: 0 }}>{card.value}</p>
              </div>
            </div>
          ))}
        </div> */}
        <div style={{
      display: 'flex',
      gap: '6px',
      marginBottom: '24px',
      justifyContent: 'space-evenly',
      flexWrap: 'wrap',
    
    }}>
      {[
        {
          icon: <FaIndianRupeeSign />,
          label: 'Total Sales',
          value: `₹${dashboardStats.revenue.toFixed(2)}`,
          bgColor: '#fef3c7',
          color: '#f59e0b',
        },
        {
          icon: <Package size={24} />,
          label: 'Total Products',
          value: dashboardStats.totalProducts,
          bgColor: '#dbeafe',
          color: '#2563eb',
        },
        {
          icon: <Archive size={24} />,
          label: 'Total Inventory',
          value: dashboardStats.totalInventoryCount,
          bgColor: '#d1fae5',
          color: '#10b981',
        },
        {
          icon: <Package size={24} />,
          label: 'In Stock',
          value: dashboardStats.inStockCount,
          bgColor: '#d1fae5',
          color: '#10b981',
        },
        {
          icon: <AlertCircle size={24} />,
          label: 'Out of Stock',
          value: dashboardStats.outOfStockCount,
          bgColor: '#fee2e2',
          color: '#ef4444',
        },
        {
          icon: <ShoppingCart size={24} />,
          label: 'Total Orders',
          value: dashboardStats.totalOrders,
          bgColor: '#ede9fe',
          color: '#8b5cf6',
        },
      ].map((card, index) => (
        <div
          key={index}
          style={{
            background: '#fff',
            borderRadius: '8px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
            padding: '16px',
            height: '110px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <div style={{
            display: 'flex',
            flexDirection:"column",
            alignItems: 'baseline',
            marginBottom: '12px'
          }}>
            <div style={{
              backgroundColor: card.bgColor,
              color: card.color,
              padding: '5px',
              borderRadius: '50%',
              display: 'flex',
              
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '10px'
            }}>
              {card.icon}
            </div>
            <p style={{ fontSize: '14px',fontWeight:"600"}}>{card.label}</p>
          </div>
          <p style={{ fontSize: '14px', fontWeight: 'bold', margin: 0 }}>{card.value}</p>
        </div>
        
      ))}
    </div>
       
        <div style={{marginLeft:"5%",marginRight:"3rem"}}>
        <div>
          <h3 style={{ fontSize: '20px', fontWeight: '600' }}>Analytics Dashboard</h3>
        </div>

        <div style={{ display: 'flex', gap: '10px', marginBottom: '24px', flexWrap: 'wrap' }}>
          {/* Orders Chart */}
          <div style={{
            background: '#fff',
            borderRadius: '8px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
            padding: '16px',
            flex: '1 1 45%',
            minWidth: '300px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <h4 style={{ fontSize: '16px', fontWeight: '600', margin: 0 }}>Orders</h4>
              <FilterControls
                filter={ordersFilter}
                setFilter={setOrdersFilter}
                isLoading={isLoading.orders}
              />
            </div>
            <div style={{ height: '256px' }}>
              <Line data={ordersChartData} options={chartOptions} />
            </div>
          </div>

          {/* Revenue Chart */}
          <div style={{
            background: '#fff',
            borderRadius: '8px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
            padding: '16px',
            flex: '1 1 45%',
            minWidth: '300px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <h4 style={{ fontSize: '16px', fontWeight: '600', margin: 0 }}>Revenue</h4>
              <FilterControls
                filter={revenueFilter}
                setFilter={setRevenueFilter}
                isLoading={isLoading.revenue}
              />
            </div>
            <div style={{ height: '256px' }}>
              <Line data={revenueChartData} options={chartOptions} />
            </div>
          </div>
        </div>
        </div>
        {/* Product Categories Pie Chart
        <div style={{
          background: '#fff',
          borderRadius: '8px',
          boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
          padding: '16px',
          marginBottom: '24px',
          minWidth: '300px'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '16px'
          }}>
            <h4 style={{ fontSize: '18px', fontWeight: '600' }}>
              Product Categories {isLoading.categories && "(Loading...)"}
            </h4>
          </div>
          <div style={{ height: '256px' }}>
            <Pie data={categoryChartData} options={pieChartOptions} />
          </div>
        </div>

        Recent Orders Table
        <div style={{
          background: '#fff',
          borderRadius: '8px',
          boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
          padding: '16px',
          marginBottom: '24px'
        }}>
          <h4 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '16px' }}>Recent Orders</h4>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead style={{ backgroundColor: '#f9fafb' }}>
                <tr>
                  {['Order ID', 'Date', 'Amount', 'Status'].map((heading) => (
                    <th key={heading} style={{
                      padding: '12px 24px',
                      textAlign: 'left',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#6b7280',
                      textTransform: 'uppercase',
                      borderBottom: '1px solid #e5e7eb'
                    }}>{heading}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {orders.slice(0, 5).map((order, index) => (
                  <tr key={order._id || index} style={{ borderBottom: '1px solid #e5e7eb' }}>
                    <td style={{ padding: '12px 24px' }}>#{(order._id || index.toString()).slice(-6)}</td>
                    <td style={{ padding: '12px 24px' }}>
                      {new Date(order.createdAt || order.date || Date.now()).toLocaleDateString()}
                    </td>
                    <td style={{ padding: '12px 24px' }}>${order.productPrice?.toFixed(2) || '0.00'}</td>
                    <td style={{ padding: '12px 24px' }}>
                      <span style={{
                        padding: '2px 8px',
                        backgroundColor: '#d1fae5',
                        color: '#065f46',
                        fontSize: '12px',
                        fontWeight: '600',
                        borderRadius: '9999px'
                      }}>
                        {order.status || 'Completed'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div> */}
      </div>

       <div className="btn-sidebar-account">
                      <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
                          <BsMenuButtonWideFill />
                      </button>
                  </div>
      
                  <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
                      <div className="canvas-wrapper">
                          <header className="canvas-header">
                              <span className="title">SIDEBAR ACCOUNT</span>
                              {/* <SideNavbaBarDashboard /> */}
                              <span data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp /></span>
                          </header>
                          
                          <div className="canvas-body sidebar-mobile-append"> </div>
                      </div>
                  </div>
    </>
  );
};

export default SalesDashboard;